import { translations } from './translations'

type Language = 'en' | 'ja'
export type JapaneseText = keyof typeof translations
type Variables = Record<string, string | number>

export const lang: Language = window.location.host.includes('en-') ? 'en' : 'ja'

export const l = (text: JapaneseText, variables: Variables = {}): string => {
  const localizedText = lang === 'ja' ? text : translations[text][lang]
  return localizedText.replace(/\{(\w+)\}/g, (placeholder, name: string) => {
    return name in variables ? String(variables[name]) : placeholder
  })
}
